import TitleScreen from "./title-screen";
import GameScreen from "./game-screen";
import StoryDialog from "./story-dialog";
import LookDialog from "./look-dialog";
import QuipDialog from "./quip-dialog";
import PauseDialog from "./pause-dialog";
import CompleteDialog from "./complete-dialog";
import CreditsDialog from "./credits-dialog";
import DebugDialog from "./debug-dialog";
import ControlsDialog from "./controls-dialog";
import { Commands, Context } from "../engine/commands";
import Input from "../engine/input";

const Views = {
  TitleScreen: new TitleScreen(),
  GameScreen: new GameScreen(),
  StoryDialog: new StoryDialog(),
  LookDialog: new LookDialog(),
  QuipDialog: new QuipDialog(),
  PauseDialog: new PauseDialog(),
  CompleteScreen: new CompleteDialog(),
  DebugDialog: new DebugDialog(),
  ControlsSettings: new ControlsDialog(),
  CreditsDialog: new CreditsDialog(),
}

const KeyboardControls = {
  KeyW: Input.MoveUp,
  KeyA: Input.MoveLeft,
  KeyS: Input.MoveDown,
  KeyD: Input.MoveRight,

  KeyK: Input.MoveUp,
  KeyH: Input.MoveLeft,
  KeyJ: Input.MoveDown,
  KeyL: Input.MoveRight,

  ArrowUp: Input.MoveUp,
  ArrowLeft: Input.MoveLeft,
  ArrowDown: Input.MoveDown,
  ArrowRight: Input.MoveRight,
  
  Enter: Input.Ok,
  Space: Input.Ok,
  Escape: Input.Cancel,
  Backspace: Input.Cancel,

  KeyQ: Input.Look,
  Slash: Input.Look,
  KeyZ: Input.Look,

  KeyX: Input.Utility,
  KeyC: Input.Utility,

  Comma: Input.FocusLeft,
  Period: Input.FocusRight,

  Dead: Input.ShowDebug,
  Backquote: Input.ShowDebug
}

const GamepadControls = {
  StickUp: Input.MoveUp,
  StickDown: Input.MoveDown,
  StickLeft: Input.MoveLeft,
  StickRight: Input.MoveRight,
  DpadUp: Input.MoveUp,
  DpadDown: Input.MoveDown,
  DpadLeft: Input.MoveLeft,
  DpadRight: Input.MoveRight,

  ButtonA: Input.Ok,
  ButtonB: Input.Cancel,
  ButtonX: Input.Utility,
  ButtonY: Input.Look,
  ButtonLB: Input.FocusLeft,
  ButtonRB: Input.FocusRight
}

function mapGamepad(code) {
  if (GamepadControls.hasOwnProperty(code)) {
    return GamepadControls[code];
  }
  return false;
}

function mapKeypress(code) {
  if (KeyboardControls.hasOwnProperty(code)) {
    return KeyboardControls[code];
  }
  return false;
}

class ScreenStack {
  constructor(stage, gamepad) {
    // TODO: combined game state, world and stage object?
    this.stage = stage;
    this.gamepad = gamepad;
    this.screenStack = [];
    this.pushScreen(Views.TitleScreen);
  }

  get screen() {
    return this.screenStack[this.screenStack.length - 1];
  }

  switchScreen(nextScreen, context) {
    this.popScreen(context);
    this.pushScreen(nextScreen);
  }

  pushScreen(nextScreen, context) {
    this.screenStack.push(nextScreen);
    nextScreen.activate(context, this);
  }

  popScreen(context) {
    let prevScreen = this.screenStack.pop();
    prevScreen.deactivate(context);
    if (this.screen?.reactivate) this.screen.reactivate();
  }

  dispatchCommand(command) {
    if (!command) return;

    if (command.context == Context.Player) {
      this.stage.player.pushCommand(command);
    } else if (command.context == Context.Screen) {
      this.pushCommand(command);
    }
  }

  handleGamepadButton(ev) {
    const input = mapGamepad(ev.detail.code);
    if (input === false) return;
    const command = this.screen.handleInput(input, this.stage);
    this.dispatchCommand(command);
  }

  handleKeypress(ev) {
    const input = mapKeypress(ev.code);
    if (input === false) return;
    const command = this.screen.handleInput(input, this.stage);
    this.dispatchCommand(command);
    ev.preventDefault();
  }

  handleClick(ev) {
    const command = this.screen.handleClick(ev, this.stage);
    this.dispatchCommand(command);
  }

  handleRightClick(ev) {
    const command = this.screen.handleRightClick(ev, this.stage);
    this.dispatchCommand(command);
  }

  handleTransition(ev) {
    if (ev.detail.command == "ShowStory") {
      this.pushScreen(Views.StoryDialog, ev.detail);
    } else if (ev.detail.command == "ShowQuip") {
      this.pushScreen(Views.QuipDialog, ev.detail);
    } else if (ev.detail.command == "HideStory") {
      this.popScreen(ev.detail);
    } else if (ev.detail.command == "HideLook") {
      this.popScreen(ev.detail);
    } else if (ev.detail.command == "CloseDialog") {
      this.popScreen(ev.detail);
    } else if (ev.detail.command == "DeathScreen") {
      this.pushScreen(Views.DeathScreen, ev.detail);
    } else if (ev.detail.command == "CompleteScreen") {
      this.pushScreen(Views.CompleteScreen, ev.detail);
    } else if (ev.detail.command == "RestartGame") {
      document.location.reload();
    }
  }

  handleGameEvent(ev) {
    this.stage.adventure.appendLog(ev.detail);
  }

  pushCommand(command) {
    if (command.action == "StartGame") {
      this.switchScreen(Views.GameScreen, {});
    } else if (command.action == "ShowControls") {
      this.pushScreen(Views.ControlsSettings, command.detail);
    } else if (command.action == "ShowCredits") {
      this.pushScreen(Views.CreditsDialog, command.detail);      
    } else if (command.action == "Examine") {
      this.pushScreen(Views.LookDialog, command.detail);
    } else if (command.action == "Pause") {
      this.pushScreen(Views.PauseDialog, command.detail);
    } else if (command.action == "QuitGame") {
      document.location.reload();
    } else if (command.action == "ShowDebug") {
      console.log("showdebug");
      this.pushScreen(Views.DebugDialog, this.stage);
    } else if (command.action == "HideDialog") {
      this.popScreen(command.detail);
    }
  }

  rescale() {
    this.screen.rescale();
  }

  render() {
    this.screen.render(this.stage);
  }
}

export default ScreenStack;
